export default {"NavigationMenu":"AppNavigationMenu-module__NavigationMenu__cS-0Z"};